import { AxiosInstance } from "axios"
import { AdyenAccountHolder, AdyenAccountHolderDetails, ConnectionTestResult } from "./adyenTypes"

export enum SupportAdyenQuery {
    ACCOUNT_HOLDERS = "support-adyen-account-holders",
    ACCOUNT_HOLDERS_DETAILS = "support-adyen-account-holders-details",
}

export type AdyenConnectionTestResponse = Readonly<{
    adyenConnectionTest: {
        results: Array<ConnectionTestResult>
    }
}>

export async function adyenConnectionTest(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AdyenConnectionTestResponse> {
    const response = await axios.post(
        "/acquirers/adyen/connection/test",
        {},
        {
            signal,
        },
    )

    return response.data
}

export type AdyenAccountHoldersResponse = Readonly<{
    accountHolders: Array<AdyenAccountHolder>
}>

export async function getAdyenAccountHolders(
    {},
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AdyenAccountHoldersResponse> {
    const response = await axios.get("/adyen/accountHolders", {
        signal,
    })

    return response.data
}

export type AdyenAccountHoldersDetailsResponse = Readonly<{
    accountHolder: AdyenAccountHolderDetails
}>

export async function getAdyenAccountHoldersDetails(
    { id }: { id: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<AdyenAccountHoldersDetailsResponse> {
    const response = await axios.get(`/adyen/accountHolders/${id}`, {
        signal,
    })

    return response.data
}
